export function getAssetUrl(assetPath) {
  if (typeof assetPath !== 'string' || !assetPath.trim()) return '';

  const path = assetPath.trim();
  if (/^https?:\/\//i.test(path)) return path;

  const encodedPath = path
    .replace(/^\/+/, '')
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/');
  return `${process.env.PUBLIC_URL}/${encodedPath}?v=2`;
}
